import { useState, useEffect } from 'react';
import ImgSplash from '../../assets/image/img_splash.png';
import { useTranslation } from '../../hook/useTranslation';

function Splash() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <div className="pageInner flex flex-col items-center justify-center">
      <div className="w-full text-['Pretendard']  mb-[20px] flex flex-col items-center justify-center gap-2">
        <div
          className={`text-center text-[18px] font-[700] transition-opacity duration-800 ease-in-out ${visible ? 'opacity-100' : 'opacity-0'}`}
        >
          {t('login.splash.title').split('\n').map((line, i) => (
            <span key={i}>
              {line}
              {i === 0 && <br />}
            </span>
          ))}
        </div>
      </div>
      <img
        src={ImgSplash}
        alt="splash"
        className={`
          w-[202px] h-[63px]
          transition-opacity duration-1000 ease-in-out
          ${visible ? 'opacity-100' : 'opacity-0'}
        `}
      />
    </div>
  );
}

export default Splash;
